import Vue from 'vue'
import Vuex from 'vuex'

import pathify from '@/pathify'
import Emiter from '@/store/plugins/emiter'
import modules from '@/store/modules'

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [pathify.plugin, Emiter],
  modules
})
